import React from 'react';
import PropTypes from 'prop-types';

const StepBasicInfo = ({ data, onChange }) => {
  console.log('StepBasicInfo received data:', data);
  
  const categories = [
    'Restaurant',
    'Retail',
    'Service',
    'Healthcare',
    'Education',
    'Entertainment',
    'Professional',
    'Other'
  ];

  const subcategories = {
    'Restaurant': ['Fine Dining', 'Fast Food', 'Cafe', 'Bar', 'Bakery'],
    'Retail': ['Clothing', 'Electronics', 'Grocery', 'Books', 'Home Goods'],
    'Service': ['Consulting', 'Repair', 'Cleaning', 'Beauty', 'Fitness'],
    'Healthcare': ['Hospital', 'Clinic', 'Pharmacy', 'Dental', 'Wellness'],
    'Education': ['School', 'Tutoring', 'Training', 'Online Learning', 'Daycare'],
    'Entertainment': ['Gaming', 'Movies', 'Music', 'Sports', 'Events'],
    'Professional': ['Legal', 'Accounting', 'Marketing', 'IT Services', 'Real Estate'],
    'Other': ['General', 'Specialized']
  };

  const handleChange = (field, value) => {
    console.log(`Changing ${field} to:`, value);
    onChange({ ...data, [field]: value });
  };

  const handleCategoryChange = (e) => {
    const newCategory = e.target.value;
    console.log('Category changed to:', newCategory);
    onChange({ 
      ...data, 
      category: newCategory,
      subcategory: '' // Reset subcategory when category changes
    });
  };

  const availableSubcategories = data.category ? subcategories[data.category] || [] : [];

  return (
    <div className="step-card basic-info-step">
      <div className="form-group">
        <label htmlFor="businessName">Business Name</label>
        <input
          type="text"
          id="businessName"
          value={data.businessName || ''}
          onChange={(e) => handleChange('businessName', e.target.value)}
          placeholder="Enter your business name"
          className="form-input"
        />
      </div>

      <div className="form-row">
        <div className="form-group half-width">
          <label htmlFor="category">Category</label>
          <select
            id="category"
            value={data.category || ''}
            onChange={handleCategoryChange}
            className="form-input"
          >
            <option value="">Select a category</option>
            {categories.map(cat => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
        </div>

        <div className="form-group half-width">
          <label htmlFor="subcategory">Subcategory</label>
          <select
            id="subcategory"
            value={data.subcategory || ''}
            onChange={(e) => handleChange('subcategory', e.target.value)}
            className="form-input"
            disabled={!data.category}
          >
            <option value="">Select a subcategory</option>
            {availableSubcategories.map(sub => (
              <option key={sub} value={sub}>{sub}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="description">Business Description</label>
        <textarea
          id="description"
          value={data.description || ''}
          onChange={(e) => {
            const value = e.target.value;
            if (value.length <= 500) {
              handleChange('description', value);
            }
          }}
          placeholder="Describe your business (max 500 characters)"
          className="form-textarea"
          rows="4"
        />
        <div className="char-count">
          {(data.description || '').length}/500
        </div>
      </div>
    </div>
  );
};

StepBasicInfo.propTypes = {
  data: PropTypes.shape({
    businessName: PropTypes.string,
    category: PropTypes.string,
    subcategory: PropTypes.string,
    description: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired
};

export default StepBasicInfo;
